"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'has-error': 'error',
    'is-invalid': 'error',
    'formio-tab-panel-active': 'active',
    'formio-tab-link-active': 'active',
    'formio-tab-link-container-active': 'active',
};



//////////////////
// WEBPACK FOOTER
// ./~/@formio/semantic/lib/templates/semantic/cssClasses.js
// module id = 1641
// module chunks = 0